/**
 * Platform detection for the Capacitor-wrapped native apps.
 *
 * Pirouette ships as one codebase: the web PWA and the native iOS / Android
 * apps all run the same React build. These helpers let feature code branch
 * on where it is running — e.g. use a native plugin on device and the
 * equivalent Web API in the browser.
 */
import { Capacitor } from '@capacitor/core';

export type AppPlatform = 'ios' | 'android' | 'web';

/** The platform the app is currently running on. */
export function getPlatform(): AppPlatform {
  return Capacitor.getPlatform() as AppPlatform;
}

/** True inside the native iOS or Android app; false in any browser. */
export function isNativePlatform(): boolean {
  return Capacitor.isNativePlatform();
}

/** True only inside the native iOS app. */
export function isIOS(): boolean {
  return Capacitor.getPlatform() === 'ios';
}

/** True only inside the native Android app. */
export function isAndroid(): boolean {
  return Capacitor.getPlatform() === 'android';
}
